// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7069":"2b5bbedc","8671":"c5030eaa"}[chunkId] + ".chunk.css";
};